import Axios from 'axios';

export const generatePDF = async (htmlContent, fileName)=> {
  const endpoint = process.env.VUE_APP_ENDPOINT_WS + 'generatePDF'; // Altere para o endpoint correto
  try {
    // Envia o conteúdo HTML e o nome do arquivo como parâmetros
    const response = await Axios.post(endpoint, {
      htmlContent: htmlContent,
      fileName: fileName
    },
    {
      responseType: 'blob',
    });

    // Retorna a resposta contendo o PDF gerado (presumivelmente em binário)
    return response.data;
  } catch (error) {
    // Lida com erros e os retorna
    throw new Error(`Erro ao gerar o PDF: ${error.message}`);
  }
};
